import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';
import { VerifyAccountComponent } from './components/verify-account/verify-account.component';
import { UserCompaniesListComponent } from './components/user-companies-list/user-companies-list.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LogoutComponent } from './components/logout/logout.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { RedirectBridgeComponent } from './components/redirect-bridge/redirect-bridge.component';
import { AcceptTermsComponent } from './components/accept-terms/accept-terms.component';
import { GraphUserTestComponent } from './components/graph-user-test/graph-user-test.component';
import { AcsEmailTestComponent } from './components/acs-email-test/acs-email-test.component';
import { SocialSignInTestComponent } from './components/social-sign-in-test/social-sign-in-test.component';
import { TestTempComponent } from './components/test-temp/test-temp.component';
import { GeofenceBlockedComponent } from './components/geofence-blocked/geofence-blocked.component';
import { AuthTokenInterceptor } from './interceptors/auth-token.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    VerifyAccountComponent,
    UserCompaniesListComponent,
    LogoutComponent,
    RedirectBridgeComponent,
    AcceptTermsComponent,
    GraphUserTestComponent,
    AcsEmailTestComponent,
    SocialSignInTestComponent,
    TestTempComponent,
    GeofenceBlockedComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    NgOtpInputModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
